// Format price with currency
export const formatPrice = (price) => {
  if (!price) return "0 so'm";
  return new Intl.NumberFormat('uz-UZ').format(price) + " so'm";
};

// Format phone number
export const formatPhoneNumber = (phone) => {
  if (!phone) return '';
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 12 && cleaned.startsWith('998')) {
    return `+${cleaned.slice(0, 3)} ${cleaned.slice(3, 5)} ${cleaned.slice(5, 8)} ${cleaned.slice(8, 10)} ${cleaned.slice(10)}`;
  }
  return phone;
};

// Format date
export const formatDate = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleDateString('uz-UZ', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

// Format date and time
export const formatDateTime = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleString('uz-UZ', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

// Truncate text
export const truncateText = (text, maxLength = 100) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

// Get order status color
export const getOrderStatusColor = (status) => {
  const colors = {
    pending: '#FFA500',
    confirmed: '#2196F3',
    processing: '#9C27B0',
    completed: '#4CAF50',
    cancelled: '#F44336',
  };
  return colors[status] || '#757575';
};

// Get order status text
export const getOrderStatusText = (status) => {
  const texts = {
    pending: 'Kutilmoqda',
    confirmed: 'Tasdiqlangan',
    processing: 'Jarayonda',
    completed: 'Yakunlangan',
    cancelled: 'Bekor qilingan',
  };
  return texts[status] || status;
};
